import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';

import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

import InputControl from '~/components/Input/InputControl';
import InputSelect from '~/components/Input/InputSelect';

import { editFilter, delFilter } from '../../../../store/actions';
import Input from '../Input';
import makeOperationOptions from './utils/makeOperationOptions';
import useStyles from './styles';
import sortArray from '~/utils/sortArray';

function FilterItem({
  filter,
  indexGroup,
  indexFilter,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const columns = useSelector(state => sortArray(state.get('columns'), 'asc', 'title') );
  const column = columns.find(({ field }) => field === filter.get('column'));
  const type = column ? column.type : null;
  const options = makeOperationOptions()[type];
  let styleValue = {};

  if(filter.get('operation') === 'isBlank' || filter.get('operation') === 'isPresent'){
    styleValue = {
      display: 'none'
    };
  }

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={4}>
        <div className={classes.columnRoot}>
          <div>
            <IconButton onClick={() => dispatch(delFilter(indexGroup, indexFilter))}>
              <RemoveCircleIcon className={classes.iconRemove} />
            </IconButton>
          </div>

          <div className={classes.columnFieldRoot}>
            <InputControl
              autoFocus={indexFilter === 0}
              value={filter.get('column')}
              name={'value'}
              inputComponent={InputSelect}
              onChange={({ value }) => {
                dispatch(editFilter(indexGroup, indexFilter, 'column', value));
                dispatch(editFilter(indexGroup, indexFilter, 'operation', ''));
              }}
              InputProps={{
                outValueType: 'string',
                placeholder: t('filter-label-column'),
                labelKey: 'title',
                valueKey: 'field',
                options: columns,
              }}
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={2}>
        <InputControl
          value={filter.get('operation')}
          name={'value'}
          inputComponent={InputSelect}
          onChange={({ value }) => dispatch(editFilter(indexGroup, indexFilter, 'operation', value))}
          InputProps={{
            outValueType: 'string',
            disabled: !type,
            placeholder: t('filter-label-operation'),
            options,
          }}
        />
      </Grid>

      <Grid item className={classes.lastCol} style={styleValue}>
        <Input
          autoComplete={filter.get('column') ? `filter-value-${filter.get('column')}` : 'off'}
          column={column}
          filter={filter}
          indexGroup={indexGroup}
          indexFilter={indexFilter}
        />
      </Grid>
    </Grid>
  );
}

export default React.memo(FilterItem);
